module.exports = __webpack_public_path__ + "img/icon_group_5@2x.3340c7da.png";